










































































































































import Vue from "vue"
import {Language} from "@/model/entity/language/language"
import Datatable from "@/components/datatable/Datatable.vue"
import {languageService} from "@/model/service/language/language-service"
import FileSaver from "file-saver"
import {classToClass} from "class-transformer"

export default Vue.extend({
  components: {
    Datatable
  },
  data() {
    return {
      images: [
        {url: require("@/assets/image/united-kingdom.png")},
        {url: require("@/assets/image/croatia.png")},
        {url: require("@/assets/image/slovenia.png")}
      ],
      selectedLanguages: this.$store.state.languages,
      fields: Language.getFieldDescriptionList(),
      languageService: languageService,
      selectedLanguageFilter: "",
      entity: new Language(),
      filterInputValue: "",
      allLanguages: [] as Language[],
      rawIndex: -1,
      page: 1,
      size: 12
    }
  },
  methods: {
    exportCsv() {
      this.$http.get("/language/export/csv").then(response => {
        const filename = "Languages.csv"
        const contentType = response.headers["content-type"]
        const blob = new Blob([response.data], {type: contentType})
        FileSaver.saveAs(blob, filename)
      })
    },
    navigateToImportPage() {
      this.$router.push({path: "/language_import"})
    },
    showHint() {
      this.$notify({
        title: "Tip",
        message: this.$t("language_editor.tip.save_tip").toString(),
        duration: 4000
      })
    },
    closeEdit() {
      this.entity = new Language()
      this.rawIndex = -1
    },
    editValue() {
      const vm = this
      this.languageService.modify(this.entity).then(() => {
        vm.$http.get("/language/get_languages").then(result => {
          vm.$i18n.setLocaleMessage("en", result.data.en)
          vm.$i18n.setLocaleMessage("hr", result.data.hr)
          vm.$i18n.setLocaleMessage("si", result.data.si)
          vm.closeEdit()
          vm.getData()
        })
      })
    },
    openLanguageEdit(entity: Language, index: number) {
      this.rawIndex = index
      this.entity = classToClass(entity)
    },
    getLanguages() {
      const vm = this
      this.languageService.getDefaultLanguage().then(response => {
        vm.allLanguages = (response.data as any).languageResourceList.map((item: any) => {
          item.lowerCasedValue = item.value.toLowerCase()
          return item
        })
      })
    },
    getData() {
      this.getLanguages()
    }
  },
  computed: {
    filteredLanguageResources(): Language[] {
      const filterInputValue = this.filterInputValue.toLowerCase()
      return this.allLanguages
        .filter((languageResource: any) => languageResource.lang === this.selectedLanguageFilter.toUpperCase())
        .filter(
          (languageResource: any) =>
            languageResource.key.includes(filterInputValue) ||
            languageResource.lowerCasedValue.includes(filterInputValue)
        )
    },
    pagedLanguageResources(): Language[] {
      return this.filteredLanguageResources.slice((this.page - 1) * this.size, this.page * this.size)
    },
    totalLanguageResources(): number {
      return this.filteredLanguageResources.length
    }
  },
  created() {
    this.getData()
    this.showHint()
    this.selectedLanguageFilter = this.$i18n.locale.toUpperCase()
  }
})
